import { render } from "./Notifications.vue?vue&type=template&id=4868bb54&ts=true"
import script from "./Notifications.vue?vue&type=script&lang=ts"
export * from "./Notifications.vue?vue&type=script&lang=ts"

import "./Notifications.vue?vue&type=style&index=0&id=4868bb54&lang=css"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__